import { caseDetailSpan } from '.'
import { insertTemplate } from '../insertMenu/insertTemplate'
import { replaceInitialValuesAndDates } from 'utils/tinyMCE/replaceInitialValues'
import type { Case } from 'types/case'
import type { InsertDynamicTextProps } from 'types/editor'
import { cleanAndValidateFirstLetterText } from '../firstLetterTextCleaning'

export const handleFirstLetter = ({
  editor,
  caseDetails,
  key,
  templates,
  dateFormat,
  label,
  selectedTheme,
  pageSetLocale,
}: InsertDynamicTextProps) => {
  const text = caseDetails?.[key as keyof Case]
  const { isValid, firstLetter } = cleanAndValidateFirstLetterText(text)

  if (!isValid || !firstLetter) {
    return
  }

  const firstLetterKey = `first_letter_${key}`

  const caseDetailsWithFirstLetter = {
    ...caseDetails,
    [firstLetterKey]: firstLetter,
  }

  const content = replaceInitialValuesAndDates(
    caseDetailSpan(firstLetterKey, selectedTheme, editor),
    caseDetailsWithFirstLetter,
    dateFormat,
    pageSetLocale,
  )

  templates.push({
    type: 'menuitem',
    text: label || '',
    onAction: () => insertTemplate(editor, content),
  })
}
